import Config from './../model/Config.js';
import { createErrorObject, getJSONFromURL, lookupOrReplace } from './../../util/Helper.js';

let keyList = {
    'dbg': 'debug',
    'cp': 'configPath',
    'e': 'embed',
    'l': 'logo',
    'lng': 'language',
    'p': 'projectID',
    's': 'scroll',
    't': 'transparent',
    'a': 'appMode',
    'b': 'baseUrl',
    'pf': 'projectFolder',
    'st': 'staticFolder'
};

let globalParams = null;

function getLocationVars() {
    if (globalParams === null) {
         
        var params = {};
        
        // InjectBasePath
        let cleanBasePath = process.env.API_BASE.replace(/\/$/, "")
        params.API_BASE = cleanBasePath + "";
        params.API_BASE = process.env.API_BASE + "projects/";

        // RAW PARAMS  
        window.location.search
            .substr(1)
            .split("&")
            .forEach((p) => {
                var pair = p.split("=");
                let val = pair[1];
                try {
                    val = JSON.parse(pair[1])
                } catch (e) { }
                params[lookupOrReplace(pair[0],keyList)] = val;
            });

        if (params.logo === undefined) {
            params.logo = true;
        }

        if(params.baseUrl) {
            params.baseUrl = decodeURIComponent(params.baseUrl);
        }

        if(params.configPath) {
            params.configPath = decodeURIComponent(params.configPath);
        }

        if(params.projectFolder) {
            params.projectFolder = decodeURIComponent(params.projectFolder);
        }

        if(params.staticFolder) {
            params.staticFolder = decodeURIComponent(params.staticFolder);
        }
    
        // projectID
        const url = window.location.pathname;
        if (/\/view\/(?!$)/.test(url) && url.indexOf("/view/") !== -1) {
            params.projectID = window.location.pathname.replace(/\/?$/, "").split("/").reverse()[0];
        }

        globalParams = params;
    }
    
    return globalParams;
}

function checkConfig(cfg) {
    return cfg !== undefined &&
        cfg.project !== undefined &&
        cfg.project.projectID !== null;
}

function loadConfigFromURL(url, callback, progress) {
    const hiddenDiv = document.getElementById("studio_project");
    if (hiddenDiv) {
        // hidden div provided with data
        progress({ loaded: 1, total: 1 }); // fake progress
        //decodeURIComponent
        const config = JSON.parse((hiddenDiv.innerText));
        if (checkConfig(config)) {
            callback(new Config(config), null);
        } else {
            if (config.project && config.project.projectID === null)
                callback(null, createErrorObject("invalid_project", { invalidUrl: url }));
            else
                callback(null, createErrorObject("invalid_json", config));
        }
    } else {
        getJSONFromURL(url, (data) => {
            if (checkConfig(data.payload) && data.error === undefined) {
                callback(new Config(data.payload), null);
            } else {
                if (data.error !== undefined) {
                    callback(null, createErrorObject("network_error", data.error));
                } else {
                    if (data.payload && data.payload.project.projectID === null)
                        callback(null, createErrorObject("invalid_project", { invalidUrl: url }));
                    else
                        callback(null, createErrorObject("invalid_json", data.error));
                }
                // 
            }
        }, progress);
    }
}

// EXPORTS
module.exports = {
    loadConfigFromURL,
    getLocationVars
};


// WEBPACK FOOTER //
// ./src/js/studio/service/ConfigHelper.js